import { Container } from './styled';
import PropTypes from 'prop-types';
import React from 'react';
import { Star } from './components/Star';
import { Text } from 'mol-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

const Rating = ({
    disabled,
    color,
    labelColor,
    size,
    stars,
    title = ''
}) => {

    const { t } = useTranslation();
    const { textColor } = useTheme();

    const RATINGTYPES = {
        1: t('Pésima'),
        2: t('Mala'),
        3: t('Intermedia'),
        4: t('Buena'),
        5: t('Excelente')
    };

    return (
        <>
            <Text
                color={ labelColor ?? textColor }
                fontSize="12px"
            >
                { title }
            </Text>
            <Container disabled={ !!disabled }>
                {
                    [1, 2, 3, 4, 5].map(starNumber =>
                        <Star
                            color={ color }
                            disabled={ !!disabled }
                            key={ starNumber }
                            size={ size }
                            type={ stars >= starNumber ? '' : 'border' }
                            value={ starNumber }
                        />
                    )
                }
                {
                    !!stars &&
                        <Text
                            color={ color }
                            fontSize="16px"
                            margin="0px 0px 0px 10px"
                        >
                            { RATINGTYPES[stars] }
                        </Text>
                }
            </Container>
        </>
    );
};

Rating.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    labelColor: PropTypes.string,
    size: PropTypes.string,
    stars: PropTypes.number,
    title: PropTypes.string
};

export default Rating;
